import React from "react";
import { Clock, Layers, MessageSquare, Globe, BarChart3, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { WA_ESPECIALISTA } from "../lib/site";

const PAINS = [
  { icon: Clock, text: "Processos manuais que consomem tempo da equipe" },
  { icon: Layers, text: "Informações espalhadas em planilhas, papéis e conversas" },
  { icon: MessageSquare, text: "Atendimento desorganizado e difícil de acompanhar" },
  { icon: Globe, text: "Falta de presença digital profissional" },
  { icon: BarChart3, text: "Dificuldade para acompanhar resultados do negócio" },
];

const Problems = () => (
  <section data-testid="problems-section" className="relative py-24 lg:py-32">
    <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-[#00E5FF]/8 blur-[140px]" />
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <span className="flex items-center gap-3">
              <span className="h-px w-10 bg-gradient-to-r from-[#00E5FF] to-[#8A2BE2]" />
              <span className="text-[11px] font-semibold tracking-[0.35em] text-white/50">
                PROBLEMAS QUE RESOLVEMOS
              </span>
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-3xl font-extrabold leading-[1.15] tracking-tight sm:text-4xl lg:text-[2.9rem]">
              SUA EMPRESA PODE ESTAR{" "}
              <span className="text-gradient">PERDENDO TEMPO</span> COM PROCESSOS
              QUE PODEM SER DIGITALIZADOS.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-base font-light leading-relaxed text-white/65">
              Rotinas repetitivas, retrabalho e informação perdida custam caro todos
              os meses. A digitalização transforma essa realidade.
            </p>
          </Reveal>
        </div>

        <div>
          {PAINS.map((pain, i) => (
            <Reveal key={i} delay={0.07 * i} y={20}>
              <div
                data-testid={`pain-item-${i + 1}`}
                className="group flex items-center gap-6 border-t border-white/10 py-6 transition-colors duration-300 last:border-b hover:border-[#00E5FF]/30"
              >
                <span className="font-display text-base font-bold tracking-widest text-[#7EEEFF]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="flex-1 text-base font-light text-white/75 md:text-lg">
                  {pain.text}
                </p>
                <pain.icon className="h-5 w-5 shrink-0 text-white/25 transition-colors duration-300 group-hover:text-[#00E5FF]" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-20 rounded-3xl bg-gradient-to-r from-[#00E5FF]/40 via-[#5B8CFF]/40 to-[#8A2BE2]/40 p-[1px]">
          <div className="flex flex-col items-start justify-between gap-8 rounded-[calc(1.5rem-1px)] bg-[#07070E] p-9 md:flex-row md:items-center lg:p-12">
            <p className="max-w-2xl font-display text-2xl font-bold leading-snug tracking-tight md:text-3xl">
              A EDALIX transforma essas necessidades em{" "}
              <span className="text-gradient">soluções digitais.</span>
            </p>
            <a
              href={WA_ESPECIALISTA}
              target="_blank"
              rel="noreferrer"
              data-testid="problems-cta-button"
              className="inline-flex shrink-0 items-center gap-2 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#8A2BE2] px-7 py-3.5 text-sm font-semibold text-white shadow-[0_12px_40px_-12px_rgba(138,43,226,0.6)] transition-[transform,filter] duration-300 hover:scale-[1.03] hover:brightness-110"
            >
              Falar com um especialista
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Problems;
